import { render } from "./footer.vue?vue&type=template&id=67e0b2c5&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=67e0b2c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67e0b2c5"

export default script